import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import type { MaterialType } from "@tfg/db"
import { AxiosError } from "axios"

import { materialTypeUpdateValidationType } from "@tfg/types/schemas/admin"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useUpdateMaterialTypeMutation = (
  options?: UseMutationOptions<
    MaterialType,
    unknown,
    { materialId: number; materialType: materialTypeUpdateValidationType }
  >
) =>
  useMutation<
    MaterialType,
    AxiosError,
    { materialId: number; materialType: materialTypeUpdateValidationType }
  >({
    ...options,
    mutationFn: async ({ materialId, materialType }) => {
      const res = await httpClient.patch<MaterialType>(
        `/admin/materialTypes/${materialId}`,
        materialType
      )
      return res.data
    },
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      await queryClient.invalidateQueries(["materialTypes"])
      notifications.show({
        title: "Added",
        message: `Successfully updated material type : ${variables.materialType.key}`,
        color: "green",
      })
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
      notifications.show({
        title: "Error",
        message: `Failed to update material type : ${variables.materialType.key}, ERROR : ${
          error.response?.data ?? error.response?.data ?? error.message
        }`,
        color: "red",
      })
    },
  })
